import CharingStationIconResource from "../../../assets/chargingstation.svg"
import L from "leaflet";
import { Marker } from "react-leaflet";
import { Ladestasjon } from "../../../services/RuteplanAPI";
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const chargingStationIcon = L.icon({
    iconUrl: CharingStationIconResource,
    iconRetinaUrl: CharingStationIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
})

export interface ICharingStationMarkersProps {
    ladestasjoner: Array<Ladestasjon>
}

export default function LadestasjonMarkers(props: ICharingStationMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { ladestasjoner } = props;

    return (
        <>
            {ladestasjoner && ladestasjoner.map( (ladestasjon: Ladestasjon, index: number) => {
                return (                    
                    <Marker key={ladestasjon.csmdId + index} 
                    position={[ladestasjon.location!.y, ladestasjon.location!.x]} 
                    icon={chargingStationIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(ladestasjon);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}